// PRD.275 — Elia AI Assistant Drawer (Phase 1, UI only).
//
// Lightweight suggestion pills (FR-10). Selecting one submits its text through
// the same send flow as typing. Never more than four are shown.

import { ELIA_COLORS, ELIA_FONT } from './elia-theme';

const MAX_CHIPS = 4;

export function EliaSuggestionChips({
  suggestions,
  onSelect,
  disabled = false,
}: {
  suggestions: string[];
  onSelect: (text: string) => void;
  disabled?: boolean;
}) {
  const visible = suggestions.slice(0, MAX_CHIPS);
  if (visible.length === 0) return null;

  return (
    <div
      style={{
        marginTop: 8,
        display: 'flex',
        flexWrap: 'wrap',
        gap: 8,
      }}
    >
      {visible.map((text) => (
        <button
          key={text}
          type="button"
          disabled={disabled}
          onClick={() => onSelect(text)}
          style={{
            background: ELIA_COLORS.surface,
            border: `1px solid ${ELIA_COLORS.border}`,
            borderRadius: 9999,
            padding: '7px 13px',
            fontFamily: ELIA_FONT,
            fontSize: 12,
            fontWeight: 500,
            color: ELIA_COLORS.textSecondary,
            cursor: disabled ? 'default' : 'pointer',
            opacity: disabled ? 0.5 : 1,
            whiteSpace: 'nowrap',
          }}
        >
          {text}
        </button>
      ))}
    </div>
  );
}
